import React from "react";
import { Loader2 } from "lucide-react";

export default function PageLoader() {
  return (
    <div className="min-h-[60vh] grid place-items-center" data-testid="page-loader">
      <div className="flex items-center gap-2 text-brand">
        <Loader2 className="w-4 h-4 animate-spin" />
        <span className="text-sm font-medium">Loading…</span>
      </div>
    </div>
  );
}
